import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CentralClienteRoutingModule } from './central-cliente-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CentralClienteRoutingModule
  ]
})
export class CentralClienteModule { }
